export enum ImportationsTargets {
  INBOX_ORDER = 1,
  INBOX_COURIER_EVENT = 2,
  INBOX_ORDER_COLLECTED = 3,
  INBOX_ORDER_CANCELLED = 4
}
